<app-modal [title]="title">
	@if (!submitted && !completed) {
		<ng-container [formGroup]="form">
			<div class="row">
				<div class="col-md-6">
					<div class="form-group invert-input">
						<label>Correo</label>
						<input type="text" [ngClass]="applyCssError('email')" formControlName="email" class="form-control" />
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group invert-input">
						<label>Confirmar correo</label>
						<input type="text" appBlockCopyPaste [ngClass]="applyCssError('emailConfirmation')" formControlName="emailConfirmation" class="form-control" />
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12 align-items-center justify-content-center d-flex">
					<div class="btn btn-primary" (click)="submit()">
						@if (isPending) {
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
						}
						{{ isPending ? 'Actualizando...' : 'Actualizar correo y reenviar confirmación' }}
					</div>
				</div>
			</div>
		</ng-container>
	}
	@if (submitted && !completed) {
		<div class="row">
			<div class="col-md-12 align-items-center justify-content-center d-flex">
				<div class="btn btn-primary" (click)="completed = true; title = ''; emailUpdated.emit()">continuar</div>
			</div>
		</div>
	}
	@if (submitted && completed) {
		<div class="content-text">
			Se ha enviado un nuevo correo electrónico,<br />
			revise su bandeja de entrada y la carpeta de correo no deseado
		</div>
	}
</app-modal>
